<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.0013 13.3327V7.99935M8.0013 7.99935V2.66602M8.0013 7.99935H13.3346M8.0013 7.99935H2.66797"
      :stroke="color || fillColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: ["disabled", "color"],
  computed: {
    fillColor() {
      return this.disabled ? "rgba(0, 0, 0, 0.25)" : "#004A98";
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// Plus.vue?00492467